export const REMOVAL_CONFIRMATION_TOASTS = [
    {
        title: 'cart.removalConfirmation.toast1.title',
        message: 'cart.removalConfirmation.toast1.message',
        buttonTrue: 'cart.removalConfirmation.toast1.buttonTrue',
        buttonFalse: 'cart.removalConfirmation.toast1.buttonFalse'
    },
    {
        title: 'cart.removalConfirmation.toast2.title',
        message: 'cart.removalConfirmation.toast2.message',
        buttonTrue: 'cart.removalConfirmation.toast2.buttonTrue',
        buttonFalse: 'cart.removalConfirmation.toast2.buttonFalse'
    },
    {
        title: 'cart.removalConfirmation.toast3.title',
        message: 'cart.removalConfirmation.toast3.message',
        buttonTrue: 'cart.removalConfirmation.toast3.buttonTrue',
        buttonFalse: 'cart.removalConfirmation.toast3.buttonFalse'
    },
    {
        title: 'cart.removalConfirmation.toast4.title',
        message: 'cart.removalConfirmation.toast4.message',
        buttonTrue: 'cart.removalConfirmation.toast4.buttonTrue',
        buttonFalse: 'cart.removalConfirmation.toast4.buttonFalse'
    },
    {
        title: 'cart.removalConfirmation.toast5.title',
        message: 'cart.removalConfirmation.toast5.message',
        buttonTrue: 'cart.removalConfirmation.toast5.buttonTrue',
        buttonFalse: 'cart.removalConfirmation.toast5.buttonFalse'
    },
    {
        title: 'cart.removalConfirmation.toast6.title',
        message: 'cart.removalConfirmation.toast6.message',
        buttonTrue: 'cart.removalConfirmation.toast6.buttonTrue',
        buttonFalse: 'cart.removalConfirmation.toast6.buttonFalse'
    },
    {
        title: 'cart.removalConfirmation.toast7.title',
        message: 'cart.removalConfirmation.toast7.message',
        buttonTrue: 'cart.removalConfirmation.toast7.buttonTrue',
        buttonFalse: 'cart.removalConfirmation.toast7.buttonFalse'
    },
    {
        title: 'cart.removalConfirmation.toast8.title',
        message: 'cart.removalConfirmation.toast8.message',
        buttonTrue: 'cart.removalConfirmation.toast8.buttonTrue',
        buttonFalse: 'cart.removalConfirmation.toast8.buttonFalse'
    },
    {
        title: 'cart.removalConfirmation.toast9.title',
        message: 'cart.removalConfirmation.toast9.message',
        buttonTrue: 'cart.removalConfirmation.toast9.buttonTrue',
        buttonFalse: 'cart.removalConfirmation.toast9.buttonFalse'
    },
    {
        title: 'cart.removalConfirmation.toast10.title',
        message: 'cart.removalConfirmation.toast10.message',
        buttonTrue: 'cart.removalConfirmation.toast10.buttonTrue',
        buttonFalse: 'cart.removalConfirmation.toast10.buttonFalse'
    }
];

export const PRODUCT_LOSS_WARNING_TOASTS = [
    {
        title: 'cart.productLossWarning.toast1.title',
        message: 'cart.productLossWarning.toast1.message',
        buttonTrue: 'cart.productLossWarning.toast1.buttonTrue',
        buttonFalse: 'cart.productLossWarning.toast1.buttonFalse'
    },
    {
        title: 'cart.productLossWarning.toast2.title',
        message: 'cart.productLossWarning.toast2.message',
        buttonTrue: 'cart.productLossWarning.toast2.buttonTrue',
        buttonFalse: 'cart.productLossWarning.toast2.buttonFalse'
    },
    {
        title: 'cart.productLossWarning.toast3.title',
        message: 'cart.productLossWarning.toast3.message',
        buttonTrue: 'cart.productLossWarning.toast3.buttonTrue',
        buttonFalse: 'cart.productLossWarning.toast3.buttonFalse'
    },
    {
        title: 'cart.productLossWarning.toast4.title',
        message: 'cart.productLossWarning.toast4.message',
        buttonTrue: 'cart.productLossWarning.toast4.buttonTrue',
        buttonFalse: 'cart.productLossWarning.toast4.buttonFalse'
    },
    {
        title: 'cart.productLossWarning.toast5.title',
        message: 'cart.productLossWarning.toast5.message',
        buttonTrue: 'cart.productLossWarning.toast5.buttonTrue',
        buttonFalse: 'cart.productLossWarning.toast5.buttonFalse'
    },
    {
        title: 'cart.productLossWarning.toast6.title',
        message: 'cart.productLossWarning.toast6.message',
        buttonTrue: 'cart.productLossWarning.toast6.buttonTrue',
        buttonFalse: 'cart.productLossWarning.toast6.buttonFalse'
    },
    {
        title: 'cart.productLossWarning.toast7.title',
        message: 'cart.productLossWarning.toast7.message',
        buttonTrue: 'cart.productLossWarning.toast7.buttonTrue',
        buttonFalse: 'cart.productLossWarning.toast7.buttonFalse'
    },
    {
        title: 'cart.productLossWarning.toast8.title',
        message: 'cart.productLossWarning.toast8.message',
        buttonTrue: 'cart.productLossWarning.toast8.buttonTrue',
        buttonFalse: 'cart.productLossWarning.toast8.buttonFalse'
    },
    {
        title: 'cart.productLossWarning.toast9.title',
        message: 'cart.productLossWarning.toast9.message',
        buttonTrue: 'cart.productLossWarning.toast9.buttonTrue',
        buttonFalse: 'cart.productLossWarning.toast9.buttonFalse'
    },
    {
        title: 'cart.productLossWarning.toast10.title',
        message: 'cart.productLossWarning.toast10.message',
        buttonTrue: 'cart.productLossWarning.toast10.buttonTrue',
        buttonFalse: 'cart.productLossWarning.toast10.buttonFalse'
    }
];
